export default {
  carouselApi: {
      //轮播图配置
      config: {
        getBaseConfig: 'api/screen/carouselApi/getBaseConfig',
        updateConfig: 'api/screen/carouselApi/updateConfig'
      },
      chart: {
        list: 'api/screen/carouselApi/list',
        del: 'api/screen/carouselApi/del',
        saveOrUpdate: 'api/screen/carouselApi/saveOrUpdate'
      }

  }
}
